import React, { useEffect, useState } from "react";
import { useLocation, useNavigate } from "react-router-dom";
import Pagination from "../../components/Pagination/Pagination";
import FilterDropdown from "../../components/FilterDropdown/FilterDropdown";
import Search from "../../components/Search/Search";
import AuthServiceStroage from "../../utils/auth_service/AuthServiceStorage";

import "./Home.scss";
import AxiosService from "../../utils/AxiosService";
import { toast } from "react-toastify";
import LocalStorageService from "../../utils/auth_service/AuthServiceStorage";
import PaginationInfo from "../../components/PaginationInfo/PaginationInfo";
import { APPLICATION_NAME } from "../../utils/Constant";

const manuscriptHeader = [
  "SL NO",
  "MANUSCRIPT ID",
  "SUBMISSION TITLE",
  "REJECTING JOURNAL NAME",
  "AUTHORS",
  "DECISION DATE",
  "ACTION",
];

   const initialUserLogData = {
     assignedCount: "",
     approvedCount: "",
     unresolvedCount: "",
     commentedCount: "",
   };

const Home = () => {
  const apiService = new AxiosService();
  const authDetails = AuthServiceStroage.getAuthDetails();
  const location = useLocation();
  const navigate = useNavigate();
  const [userData, setUserData] = useState({ projectId: null, projectName: ""});
  const [userName, setuserName] = useState("")
  const [totalManuscriptCount , setTotalManuscriptCount] = useState(0);
  const [searchContent , setSearchContent] = useState("");
  const [totalPaginationCount , setTotalPaginationCount] = useState(0);
  const [manuscriptsData , setmanuscriptsData] = useState([]);
  const localStorageService = LocalStorageService.getService();
  const [filter, setFilter] = useState({});
  const [currentPage , setCurrentPage] = useState(1);
   const [checked, setChecked] = useState(false);
  const [userLogData, setUserLogData] = useState([]);
  const [showTable, setShowTable] = useState(true);
  const [assignedId , setAssignedId] = useState(0);

  useEffect(() => {
    const authDetails = localStorageService.getAuthDetails();
    const projectDetails = localStorageService.getProjectDetails();
    if(!authDetails || !projectDetails){
      toast.error("Please Login to Continue", { autoClose: 2000 });
        navigate(`/${APPLICATION_NAME}/login`);
    }else{
      setUserData(JSON.parse(projectDetails));
      const user = JSON.parse(authDetails).username;
      setuserName(user);
    }

    const filterData = localStorageService.getSelectedFilter();
    setFilter(JSON.parse(filterData || "{}"));
    const commentsData = localStorageService.getCommentStatus();
    setChecked(JSON.parse(commentsData || "false"));
    localStorageService.getCurrentPage()?setCurrentPage(localStorageService.getCurrentPage()):setCurrentPage(1);
    const savedAssignedId = localStorageService.getAssignedId(); 
  if (savedAssignedId) {
    setAssignedId(parseInt(savedAssignedId));
  }
    
  }, []);

  useEffect(() => {
   if (userData.projectId && assignedId !== null) {
       if (checked) {
         const filters = { comment: !checked, noComment: true };
         console.log('assId:',assignedId)
         apiService
           .getCommentDashboardData(userData.projectId, userName, filters,assignedId)
           .then((response) => {
             setmanuscriptsData(response.data.data);
            // setTotalManuscriptCount(response.data.data.length);
             setTotalPaginationCount(response.data.data.length);
             localStorageService.setSelectedFilter(JSON.stringify({"noAction":true,"approved":true,"unresolved":true}));
             localStorageService.setTotalManuscriptCountToSession(response.data.data.length)
           })
           .catch((error) => {
             console.error("Error fetching data:", error);
             toast.error('No Data Found');
           });
           getUserLogData();
           apiService
             .getDashboardDataCount(
               userData.projectId,
               userName,
               {},
               assignedId
             )
             .then((response) => {
               setTotalManuscriptCount(response.data.data);
             });
       } else {
         MainDataFetch();
     }
     }

   }

 , [filter,checked,assignedId]);

  const manuscriptHandler = (manuscriptId,serialNumber) => {
    navigate(`/${APPLICATION_NAME}/curation`, {
      state: {
        projectId: userData.projectId,
        projectName: userData.projectName,
        manuscriptId: manuscriptId,
        totalCount: totalManuscriptCount,
        assignedId: assignedId,
        serialNumber: serialNumber,
      },
    });
  };

  const updateSearchContent =(content)=> {
    setSearchContent(content);
  };  
  const handleClick = (log) => {
    const newAssignedId = parseInt(log.assignedId);
    setAssignedId(newAssignedId);
      localStorageService.setAssignedId(newAssignedId);
    const filters = {};
    apiService
      .getDashboardDataCount(userData.projectId, userName, {}, newAssignedId)
      .then((response) => {
        setTotalManuscriptCount(response.data.data);
      });
      apiService
        .getDashboardDataCount(userData.projectId, userName,filters, newAssignedId)
        .then((response) => {
          setTotalPaginationCount(response.data.data);
           localStorageService.setTotalManuscriptCountToSession(response.data.data)
        });
  apiService
    .getDashboardData(userData.projectId, userName, 1, filters, newAssignedId)
    .then((response) => {
      setmanuscriptsData(response.data.data);
      setCurrentPage(1);
      //  localStorageService.setCurrentPageToSession(1);
      
    })
    .catch((error) => {
      console.error("Error fetching manuscript data for user log:", error);
      toast.error(error.response?.data?.message || "Failed to fetch user manuscripts", {
        autoClose: 3000,
      });
    });
};



 useEffect(() =>{

  if(searchContent !==""){
    const auth = JSON.parse(authDetails);
    apiService.searchCount(auth.userName,userData.projectName, 1, searchContent,filter,assignedId ).then((response) => {
      
      // console.log(response.data.data)
      // setTotalPaginationCount(response.data.data);
      // onPageChange(currentPage)
      // setTotalManuscriptCount(response.data)
      
      if (response.data.data > 0) {
  setTotalPaginationCount(response.data.data);
   localStorageService.setTotalManuscriptCountToSession(response.data.data)
  onPageChange(currentPage);
} else {
  setTotalPaginationCount(0);
  setmanuscriptsData([]);
}
  }).catch((error) => {
      setTotalPaginationCount(0);
       setmanuscriptsData([]);
      toast.error(error.response.data.message, {autoClose: 3000})
  })
  }else{
    MainDataFetch();
  }
 },[searchContent]);

 const onPageChange =(pagNumber) =>{
  const auth = JSON.parse(authDetails);
  if(searchContent !==""){
    apiService.searchData(auth.userName, userData.projectName, pagNumber, searchContent, filter,assignedId).then((response) => {
      setmanuscriptsData(response.data.data);
      setCurrentPage(pagNumber)
      localStorageService.setCurrentPageToSession(pagNumber);
      //  setmanuscriptsData([]);
  }).catch((error) => {
      toast.error(error.response.data.message, {autoClose: 3000})
  })
  }else{
    apiService
        .getDashboardData(userData.projectId, userName,pagNumber,filter,assignedId)
        .then((response) => {
          setmanuscriptsData(response.data.data);
          setCurrentPage(pagNumber)
            localStorageService.setCurrentPageToSession(pagNumber);
    })
  }
 
 };

const MainDataFetch = () =>{
  getUserLogData();
if(userData.projectId !=="" && userName !=="" && assignedId !=0 ){
    apiService
  .getDashboardDataCount(userData.projectId, userName,{},assignedId)
  .then((response) => {
    setTotalManuscriptCount(response.data.data);
  })
  apiService
  .getDashboardDataCount(userData.projectId, userName,filter,assignedId)
  .then((response) => {

    setTotalPaginationCount(response.data.data)
     localStorageService.setTotalManuscriptCountToSession(response.data.data)
  })
  .catch((error) => {
    toast.error(error.response.data.message, { autoClose: 3000 });
  });
  apiService
  .getDashboardData(userData.projectId, userName,1,filter,assignedId)
  .then((response) => {
    setmanuscriptsData(response.data.data);
  })
  .catch((error) => {
    toast.error(error.response.data.message, { autoClose: 3000 });
  });
}

};

 const updateFilter = (filters) =>{
   setCurrentPage(1);
   localStorageService.setCurrentPageToSession(1);
  setFilter(filters)
  localStorageService.setSelectedFilter(JSON.stringify(filters));
 };

 const resetSearch  = ()=>{
  setSearchContent(""); };

  function convertCamelCaseToSentence(str) {
    return (
      str
        // Insert space before each uppercase letter
        .replace(/([a-z])([A-Z])/g, "$1 $2")
        // Capitalize the first letter of the sentence
        .replace(/^./, (match) => match.toUpperCase())
    );
  }

 const handleCheckboxClick = () => {

   setChecked(!checked);
   localStorageService.setCommentStatus(!checked);

 };

 const getUserLogData = () => {
   const filters = { comment: checked, noComment: true };
   apiService
     .getUserLogData(userData.projectId, userName, filters)
     .then((response) => {
       console.log("---", response.data);
       setUserLogData(response.data.data);
     })
     .catch((error) => {
       console.error("Error fetching data:", error);
     });
 };

  const toggleUserLogTable = () => {
    if (!showTable) {
      getUserLogData();
    }
    setShowTable(!showTable);
  };

  const calculateUserLogTotals = () => {
  const totals = {
    assignedCount: 0,
    approvedCount: 0,
    unresolvedCount: 0,
    commentedCount: 0,
  };

  userLogData.forEach((log) => {
    totals.assignedCount += parseInt(log.assignedCount) || 0;
    totals.approvedCount += parseInt(log.approvedCount) || 0;
    totals.unresolvedCount += parseInt(log.unresolvedCount) || 0;
    totals.commentedCount += parseInt(log.commentedCount) || 0;
  });

  return totals;
};


useEffect(() => {
  const timeoutId = setTimeout(() => {

    const current=localStorageService.getCurrentPage();
    const tota = localStorageService.getTotalPaginationCount();
    // alert(current);
    // alert(tota);
  }, 2000); // Delay in milliseconds (1000ms = 1 second)

  // Optional cleanup (if component unmounts before timeout)
  return () => clearTimeout(timeoutId);
}, []);



 return (
   <div className="container-fluid">
     <div className="pt-3 ">
       <div className="d-flex justify-content-between align-items-center">
         <div>
           <h3>Manuscripts</h3>
           <p className="text-muted">
             Project: <strong>{userData.projectName}</strong> | Total
             Manuscripts: <strong>{totalManuscriptCount}</strong>
           </p>
         </div>
         <div className="relative">
           <input
             className="btn btn-primary"
             type="button"
             value={showTable ? "Hide Users Log" : "Show Users Log"}
             onClick={toggleUserLogTable}
           />
         </div>
         <Search
           updateSearchContent={updateSearchContent}
           searchContent={searchContent}
         />
       </div>

       {showTable  && (
       <div className="border rounded mb-4 mt-2 p-3">
         <h4 className="pt-2 ms-2">Users Log</h4>
         <table className="table table-hover mb-0">
           <thead>
             <tr className="bg-primary text-white">
               <th className="col bg-light text-nowrap text-secondary fs-6 fw-medium">
                 Assigned Count
               </th>
               <th className="col bg-light text-nowrap text-secondary fs-6 fw-medium">
                 Approved Count
               </th>
               <th className="col bg-light text-nowrap text-secondary fs-6 fw-medium">
                 Unresolved Count
               </th>
               <th className="col bg-light text-nowrap text-secondary fs-6 fw-medium">
                 Commented Count
               </th>
               <th className="col bg-light text-nowrap text-secondary fs-6 fw-medium">
               Due Date
               </th>
               <th className="col bg-light text-nowrap text-secondary fs-6 fw-medium">
               Description
                 </th>
              <th className="col bg-light text-nowrap text-secondary fs-6 fw-medium">
                Action
              </th>
             </tr>
             </thead>
             <tbody>
  {userLogData.map((log, index) => (
    <tr
      key={index}
      className={assignedId === parseInt(log.assignedId) ? "table-primary" : ""}
    >
      <td className="align-middle">{log.assignedCount}</td>
      <td className="align-middle">{log.approvedCount}</td>
      <td className="align-middle">{log.unresolvedCount}</td>
      <td className="align-middle">{log.commentedCount}</td>
      <td className="align-middle">{log.dueDate}</td>
      <td className="align-middle">{log.description}</td>
      <td className="align-middle">
        <button
          className="btn btn-primary"
          onClick={() => handleClick(log)} // <-- pass full object
        >
          get Data
        </button>
      </td>
    </tr>
  ))}
                 <tr className="bg-light fw-bold">
    <td className="align-middle">{calculateUserLogTotals().assignedCount}</td>
    <td className="align-middle">{calculateUserLogTotals().approvedCount}</td>
    <td className="align-middle">{calculateUserLogTotals().unresolvedCount}</td>
    <td className="align-middle">{calculateUserLogTotals().commentedCount}</td>
    <td className="align-middle">-</td>
    <td className="align-middle">Total</td>
    <td className="align-middle">-</td>
  </tr>


</tbody>

         </table>
       </div>
        )} 

       {assignedId !=0 && (<div className="border rounded mb-4">
         <div className="d-flex justify-content-between align-items-center  p-3">
           <div className="w-75">
             {/* {!checked && ( */}
               <PaginationInfo
                 dataName={"Showing "}
                 totalItems={totalPaginationCount}
                 currentPage={currentPage}
               />
             {/* )} */}
           </div>
           {/* <select className="form-select" style={{ maxWidth: "200px" }}>
              <option>Filter by: No Action</option>
              <option>Filter 1</option>
              <option>Filter 2</option>
            </select> */}
           <div className="form-check form-check-lg">
             <label htmlFor="comments" className="form-check-label">
               Comments
             </label>
             <input
               type="checkbox"
               id="comments"
               checked={checked}
               onChange={handleCheckboxClick}
               className="form-check-input"
             />
           </div>

           <FilterDropdown
             updateFilter={updateFilter}
             commentChecked={checked}
           />
         </div>
         {searchContent && (
           <div className="d-flex align-items-center p-3 border-top search-info">
             <strong>Search results for:</strong>
             <span>{searchContent}</span>
             <i className="bi bi-x" onClick={resetSearch}></i>
           </div>
         )}

         <table className="table table-hover mb-0">
           <thead className="">
             <tr className="bg-primary">
               {manuscriptHeader.map((item, index) => (
                 <th
                   className="col bg-light text-nowrap text-secondary fs-6 fw-medium"
                   key={index}
                 >
                   {item}
                 </th>
               ))}
             </tr>
           </thead>
           <tbody>
             {manuscriptsData.map((manuscript, index) => (
               <tr
                 key={index}
                 onClick={() => manuscriptHandler(manuscript.manuscriptId,(currentPage*10)-10+index+1)}
               >
                <td className="align-middle">{(currentPage*10)-10+index+1}</td>
                 <td className="align-middle">{manuscript.manuscriptId}</td>
                 <td className="align-middle fw-medium">
                   {manuscript.submissionTitle}
                 </td>
                 <td className="align-middle">{manuscript.journalName}</td>
                 <td className="align-middle">{manuscript.authorFullName}</td>
                 <td className="align-middle">{manuscript.decisionDate}</td>
                 <td className="align-middle">
                   {manuscript.finalStatus === "noAction"
                     ? "-"
                     : convertCamelCaseToSentence(manuscript.finalStatus)}
                 </td>
               </tr>
             ))}
           </tbody>
         </table>
         <div className="m-3">
            {!checked && ( 
             <Pagination
               totalCount={totalPaginationCount}
               currentPage={currentPage}
               onPageChange={onPageChange}
             />
            )} 
         </div>
       </div>
       )}
     </div>
   </div>
 );
};

export default Home;
